import { z, infer as ZodInfer } from "zod"

export const createLayerRequestSchema = z.object({
    layerType: z.enum(["ortho", "hotspot"]),
    layerName: z.string().optional(),
    /** Override the layer window start time. Accepts any ISO 8601 string.
     *  Useful when testing against pre-captured datasets where EXIF timestamps are in the past. */
    createdAt: z.string().optional(),
})

export type CreateLayerRequest = ZodInfer<typeof createLayerRequestSchema>
